// Parses bot message content containing [[VENUE | key=value | ... ]] markers.
// Returns an ordered array of segments: {type:'text', text} and {type:'venue', data}.
// Also silently drops INCOMPLETE venue cards (so partial markers don't flicker during streaming).

const VENUE_RE = /\[\[VENUE\s*\|([^\]]+?)\]\]/g;

function parseVenueMarker(inside) {
  // inside: " name=X | zone=Y | rooms=Z | ..."
  const parts = inside.split("|").map((p) => p.trim()).filter(Boolean);
  const data = {};
  for (const p of parts) {
    const eq = p.indexOf("=");
    if (eq === -1) continue;
    const k = p.slice(0, eq).trim().toLowerCase();
    const v = p.slice(eq + 1).trim();
    data[k] = v;
  }
  // Only keep cards that have at least a name
  if (!data.name) return null;

  // Normalize tags into array
  if (data.tags) {
    data.tags = data.tags
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);
  } else {
    data.tags = [];
  }
  return data;
}

export function parseMessage(text) {
  if (!text) return [{ type: "text", text: "" }];

  // Strip incomplete trailing "[[VENUE..." (streaming in progress) so we don't
  // show half of a card.
  let working = text;
  const openIdx = working.lastIndexOf("[[VENUE");
  if (openIdx !== -1) {
    const closeIdx = working.indexOf("]]", openIdx);
    if (closeIdx === -1) {
      working = working.slice(0, openIdx);
    }
  }

  const segments = [];
  let lastIndex = 0;
  let match;
  const re = new RegExp(VENUE_RE.source, "g");
  while ((match = re.exec(working)) !== null) {
    if (match.index > lastIndex) {
      segments.push({
        type: "text",
        text: working.slice(lastIndex, match.index),
      });
    }
    const venue = parseVenueMarker(match[1]);
    if (venue) segments.push({ type: "venue", data: venue });
    lastIndex = re.lastIndex;
  }
  if (lastIndex < working.length) {
    segments.push({ type: "text", text: working.slice(lastIndex) });
  }
  // Clean up: collapse pure-whitespace text segments
  return segments
    .map((s) =>
      s.type === "text" ? { ...s, text: s.text.replace(/\n{3,}/g, "\n\n") } : s
    )
    .filter((s) => !(s.type === "text" && !s.text.trim()));
}
